<template>
  <b-modal
    id="multime-modal"
    size="lg"
    hide-footer
    body-class="multime-body"
    @hide="$emit('hideMultimeModal')"
  >
    <add-roles v-if="currentStep === 0" />
    <add-roles-end v-else-if="currentStep === 1" @next="changeStep(2)" />
    <characteristics-start v-else-if="currentStep === 2" @next="changeStep(3)" />
    <add-characteristics v-else-if="currentStep === 3" @exerciseCompleted="changeStep(4)" />
    <exercise-end
      v-else
      :buttonPrimaryText="
        isInCourse
          ? trans('courses.multicircle_exercise.stream_back_to_main_page')
          : trans('courses.multicircle_exercise.show_me')
      "
      :buttonSecondaryText="
        isInCourse
          ? trans('courses.multicircle_exercise.stream_show_me')
          : trans('courses.multicircle_exercise.back_to_main_page')
      "
      @primaryClicked="isInCourse ? $emit('exerciseCompleted') : $emit('goToResult')"
      @secondaryClicked="isInCourse ? $emit('goToResult') : $emit('exerciseCompleted')"
    />
  </b-modal>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import AddRoles from "./AddRoles";
import AddRolesEnd from "./AddRolesEnd";
import CharacteristicsStart from "./CharacteristicsStart";
import AddCharacteristics from "./AddCharacteristics";
import ExerciseEnd from "./ExerciseEnd";

export default {
  name: "MultiMeModal",
  props: {
    isInCourse: Boolean,
    isAdmin: Boolean,
  },
  components: {
    AddRoles,
    AddRolesEnd,
    CharacteristicsStart,
    AddCharacteristics,
    ExerciseEnd,
  },
  methods: {
    ...mapMutations({
      changeStep: "multime/changeStep",
    }),
  },
  computed: {
    ...mapGetters({
      currentStep: "multime/getCurrentStep",
      roles: "multime/getSavedRoles",
    }),
  },
};
</script>

<style scoped lang="scss">
::v-deep .multime-body {
  min-height: 400px;
  padding: 0 1.5rem 1.5rem 1.5rem;
}
</style>
